import { useState, useEffect } from 'react';
import type { Paper, Topic } from '../types';

export const usePersistence = () => {
    const [topics, setTopics] = useState<Topic[]>(() => {
        try {
            const saved = localStorage.getItem('eolas_topics');
            if (!saved) return [
                { name: 'Machine Learning', dateFrom: '', dateTo: '' },
                { name: 'CRISPR', dateFrom: '', dateTo: '' },
                { name: 'Climate Change', dateFrom: '', dateTo: '' },
                { name: 'Quantum Computing', dateFrom: '', dateTo: '' }
            ];

            const parsed = JSON.parse(saved);

            // Migration: Handle old string[] format
            if (Array.isArray(parsed) && parsed.length > 0 && typeof parsed[0] === 'string') {
                return (parsed as string[]).map(name => ({ name, dateFrom: '', dateTo: '' }));
            }

            return parsed;
        } catch {
            return [
                { name: 'Machine Learning', dateFrom: '', dateTo: '' },
                { name: 'CRISPR', dateFrom: '', dateTo: '' },
                { name: 'Climate Change', dateFrom: '', dateTo: '' },
                { name: 'Quantum Computing', dateFrom: '', dateTo: '' }
            ];
        }
    });

    const [bookmarks, setBookmarks] = useState<Paper[]>(() => {
        try {
            const saved = localStorage.getItem('eolas_bookmarks');
            return saved ? JSON.parse(saved) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem('eolas_topics', JSON.stringify(topics));
    }, [topics]);

    useEffect(() => {
        localStorage.setItem('eolas_bookmarks', JSON.stringify(bookmarks));
    }, [bookmarks]);

    return {
        topics,
        setTopics,
        bookmarks,
        setBookmarks
    };
};
